// extracted by mini-css-extract-plugin
var _1 = "LabeledGraphicFormValueItem_actions__521ac";
var _2 = "LabeledGraphicFormValueItem_active__f83a7";
var _3 = "LabeledGraphicFormValueItem_floatingHeader__ee3a6";
var _4 = "LabeledGraphicFormValueItem_header__42543";
var _5 = "LabeledGraphicFormValueItem_icons__913f7";
var _6 = "LabeledGraphicFormValueItem_root__d05bb";
var _7 = "LabeledGraphicFormValueItem_title__8d97c";
export { _1 as "actions", _2 as "active", _3 as "floatingHeader", _4 as "header", _5 as "icons", _6 as "root", _7 as "title" }
